<template>
  <section class="section-slider">
     <div class="container">
        <div class="inner">
            <div class="slider">
                <carousel :auto="4500" :speed="500" :prev-html="sliderOpt.control" :next-html="sliderOpt.control" :watch-items="data">
                    <carousel-item v-for="(items, index) in data" :key="index" class="slider--item">
                      <div class="slider__inner">
                        <h2>{{ items.title }}</h2>
                        <p v-html="items.body"></p>
                      </div>
                    </carousel-item>
                </carousel>
            </div> 

         </div>
     </div>
  </section>
</template>
<script>
/*
    Carousel components : @author => https://github.com/lsycxyj/vue-l-carousel
*/
import { slider } from '@/contents/homepage.json'
import { Carousel, CarouselItem } from 'vue-l-carousel'

export default {
  components: { Carousel, CarouselItem },
  data () {
    return {
      data: slider,
      sliderOpt: {
        'control': '<span></span>'
      }
    }
  },
  methods: {
  }
}
</script>
<style lang="css" scoped>
@import 'vue-l-carousel/dist/main.css';

</style>



// WEBPACK FOOTER //
// src/components/Carousel.vue